import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { Component, OnInit } from '@angular/core';
import { SettingsService } from 'src/app/views/settings/settings.service';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { SharedComponentsModule } from 'src/app/shared/components/shared-components.module';
import { offset } from 'handsontable/helpers/dom';
import moment from 'moment';
import alasql from 'alasql';
import * as XLSX from 'xlsx';
import { CookieService } from 'ngx-cookie-service';
import { DataTransferService } from 'src/app/shared/services/data-transfer.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { RfqGenerateFormService } from '../../dashboard/rfq/rfq-generate-form/rfq-genearte-form.service';
import { FullLoaderService } from 'src/app/shared/services/full-loader.service';
import { QuoteService } from '../../dashboard/quote/quote.service';
import { ViewChild } from '@angular/core';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { SupplierService } from 'src/app/views/settings/suppliers/supplier.service';
import { v4 as uuidv4 } from 'uuid';
import { AwsSdkService } from 'src/app/shared/services/aws-sdk.service';
import { WebApiService } from 'src/app/shared/services/web-api.service';
import { RfqTokenAuthService } from 'src/app/shared/services/rfq-token-auth.service';
// import { ChatService } from 'src/app/shared/services/chat.service';

interface Attachment {
  name: string;
  // systemName: string;
  // fileKey: string;
  s3_path: string;
}

@Component({
  // Issue 7 — force Material form-field labels on this screen to float to
  // the top so they never rest over / overlap the input value.
  providers: [
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { floatLabel: 'always' } },
  ],
  selector: 'app-rfq-token-details',
  templateUrl: './rfqDetails.component.html',
  styleUrls: ['./rfqDetails.component.css'],
})
export class RfqTokenDetailsComponent implements OnInit {
  @ViewChild('supplierTable') table!: DatatableComponent;
  showLoader: boolean = false;
  showDetailSection: boolean = false;
  isWrapDescription: boolean = false;
  userId!: number;
  userRole!: string;
  isForm1Expand: boolean = true;
  isForm2Expand: boolean = true;
  isForm3Expand: boolean = true;
  isForm4Expand: boolean = true;
  isForm5Expand: boolean = true;
  isForm6Expand: boolean = true;
  isForm7Expand: boolean = true;
  isForm8Expand: boolean = true;
  isForm9Expand: boolean = true;
  isForm10Expand: boolean = true;
  isForm11Expand: boolean = true;
  showChatHistoryButton: boolean = false;

  rfqId!: number;
  quoteId!: any;
  lineItemData: any[] = [];
  lineItemDataAttachment: any[] = [];
  headerData: any;
  secondFormGroup!: UntypedFormGroup;

  rfqattachmentSection: boolean = false;
  rfqattachmentImages: any[] = [];
  currentIndex = 0;

  buyerAttachmentSection: boolean = false;
  buyerAttachmentUrl: any[] = [];

  isCollapsed: boolean = false;
  buyerHeaderAttachmentSection: boolean = false;
  buyerHeaderAttachmentUrl: any;

  displayedColumns = [
    'position',
    'partNumber',
    'partType',
    'brand',
    'itemDescription',
    'supplierComment',
    'buyerComment',
    'unit',
    'quantity',
    'unitCost',
    'discount',
    'discountedUnitPrice',
    'totalCost',
  ];

  declineReason: string = '';
  showDeclineConfirmationDialogue: boolean = false;
  tempFormGroup!: UntypedFormGroup;
  uploadedAttachmentsArray: any[] = [];
  constructor(
    private SettingsService: SettingsService,
    private router: Router,
    private cookieService: CookieService,
    private dataTransferService: DataTransferService<any>,
    private snack: MatSnackBar,
    private RfqGenerateFormService: RfqGenerateFormService,
    private activatedRoute: ActivatedRoute,
    private FullLoaderService: FullLoaderService,
    private quoteService: QuoteService,
    private _formBuilder: UntypedFormBuilder,
    private supplierService: SupplierService,
    private fullLoaderService: FullLoaderService,
    private awsSdkService: AwsSdkService,
    private webApiService: WebApiService,
    private rfqTokenAuth: RfqTokenAuthService,
    // private chatService: ChatService
  ) {}

  toggleBlur(): void {
    const element = document.querySelector('.blurry');
    if (element) {
      element.classList.toggle('blur');
    } else {
      console.warn('Element with class "blurry" not found.');
    }
  }

  // async toggleRfqAttachmentImage(value: boolean, row?: any){

  //   const data = await this.fetchRfqDetailsAttachments(row.rfqLineItemDetailsId);
  //   console.log("lineItemDataAttachment",this.lineItemDataAttachment)
  //   if (url) {
  //     this.rfqattachmentImages.push(url)
  //   } else {
  //     this.rfqattachmentImages=[]
  //   }
  //   this.toggleBlur();
  //   this.rfqattachmentSection = value;
  // }

  async toggleRfqAttachmentImage(value: boolean, row?: any) {
    if (row) {
      try {
        const data = await this.fetchRfqDetailsAttachments(
          row.rfqLineItemDetailsId
        );
        console.log('lineItemDataAttachment', data);

        if (
          this.lineItemDataAttachment.length > 0 &&
          Array.isArray(this.lineItemDataAttachment)
        ) {
          this.rfqattachmentImages = [];

          this.lineItemDataAttachment.forEach((item) => {
            if (item.s3Path) {
              this.rfqattachmentImages.push(item.s3Path);
            }
          });
          console.log('rfqattachment', this.rfqattachmentImages);
        } else {
          this.rfqattachmentImages = [
            'https://ihm-assets-dev.s3-eu-west-1.amazonaws.com/no-image-available-grid.jpg',
          ];
        }
      } catch (error) {
        console.error('Error fetching RFQ attachment data:', error);
        this.rfqattachmentImages = [];
      }
      console.log('rfattachmentImages', this.rfqattachmentImages);
    }
    this.toggleBlur();
    this.rfqattachmentSection = value;
  }

  toggleBuyerAttachmentImage(value: boolean, row?: any) {
    this.buyerAttachmentSection = value;
  }

  async toggleBuyerHeaderAttachmentImage(value: boolean, url?: any) {
    if (url) {
      this.buyerHeaderAttachmentUrl = url;
    }
    this.toggleBlur();
    this.buyerHeaderAttachmentSection = value;
  }

  nextSlide() {
    this.currentIndex =
      (this.currentIndex + 1) % this.rfqattachmentImages.length;
  }

  prevSlide() {
    this.currentIndex =
      (this.currentIndex - 1 + this.rfqattachmentImages.length) %
      this.rfqattachmentImages.length;
  }

  isPdf(url: string): boolean {
    return url?.toLowerCase().endsWith('.pdf');
  }

  isImage(url: string): boolean {
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.svg'];
    return imageExtensions.some((ext) => url.toLowerCase().endsWith(ext));
  }

  async ngOnInit() {
    const token = this.rfqTokenAuth.getToken();
    if (!token) {
      this.snack.open('Session expired. Please re-open the RFQ link.', 'OK', {
        duration: 4000,
      });
      this.router.navigate(['/tokenLogin']);
      return;
    }
    this.FullLoaderService.showLoader();
    this.rfqId = this.activatedRoute.snapshot.params['rfqId'];
    const tokenSupplierId = this.rfqTokenAuth.getSupplierId();
    this.userId = tokenSupplierId ? Number(tokenSupplierId) : 0;
    this.userRole = 'Suppliers';
    this.showChatHistoryButton = true;

    this.tempFormGroup = this._formBuilder.group({
      // quote details
      quoteId: [null],
      rfqId: [null],
      quoteRefNumber: [null],
      supplierRfqDetailsId: [null],
      quoteDate: [new Date()],
      priceGoodUntilDate: [null],
      offeredQuality: [null],
      onTimeDeliveryOrderDate: [null],
      quotedDeliveryInDays: [null],

      // incoterms details
      incoterms: [null],
      incotermLocation: [null],

      // my details
      supplierId: [null],
      supplierContactName: [''],
      supplierEmail: [null],
      supplierTelephone: [null],
      supplierMobile: [null],
      supplierCompanyEmail: [null],
      supplierCurrency: [null],

      // comment
      supplierComment: [null],
      buyerComment: [null],
      quoteHeaderAttachmentType: [null],
      quoteHeaderAttachments: [null],

      // freight forwarder
      quoteFreightForwarderId: [null],
      freightForwarderDetailsId: [null],
      freightForwarderCompanyName: [null],
      pic: [null],
      freightForwarderJobTitle: [null],
      freightForwarderEmailId: [''],
      freightForwarderPhone: [null],
      freightForwarderFax: [null],
      freightForwarderAddress: [null],
      packaging: [null],
      modeOfTransport: [null],
    });

    this.secondFormGroup = this._formBuilder.group({
      quoteLineItemHeaderId: [null],
      quoteLineItemListPriceSubtotal: [null],
      quoteLineItemDiscount: [null],
      quoteLineItemSubtotal: [null],
      quoteLineItemGeneralDiscountType: [null],
      quoteLineItemGeneralDiscountValue: [null],
      quoteLineItemFreightTotal: [null],
      quoteLineItemFreight: [null],
      quoteLineItemTotal: [null],
    });

    this.FullLoaderService.showLoader();

    if (this.userRole == 'Suppliers') {
      this.supplierService
        .getSupplierUpdateDataByUserIdByRfqToken()
        .then((data) => {
          this.tempFormGroup.patchValue({
            supplierId: this.userId || null,
            supplierContactName: data.data[0].companyName || '',
            supplierEmail: data.data[0].primaryEmail || '',
            supplierTelephone: data.data[0].phone1 || '',
            supplierMobile: data.data[0].phone1 || '',
            supplierCompanyEmail: data.data[0].primaryEmail || '',
            supplierCurrency: [null],
          });
        });

    const dateString1 = this.tempFormGroup.value.quoteDate
      ? moment(this.tempFormGroup.value.quoteDate).format(
          'YYYY-MM-DDTHH:mm:ss'
        ) + 'Z'
      : null;
    const dateString2 = this.tempFormGroup.value.priceGoodUntilDate
      ? moment(this.tempFormGroup.value.priceGoodUntilDate).format(
          'YYYY-MM-DDTHH:mm:ss'
        ) + 'Z'
      : null;
    const dateString3 = this.tempFormGroup.value.onTimeDeliveryOrderDate
      ? moment(this.tempFormGroup.value.onTimeDeliveryOrderDate).format(
          'YYYY-MM-DDTHH:mm:ss'
        ) + 'Z'
      : null;

    this.tempFormGroup.patchValue({
      quoteDate: dateString1,
      priceGoodUntilDate: dateString2,
      onTimeDeliveryOrderDate: dateString3,
      rfqId: this.rfqId,
    });

    const data = await this.quoteService.getlastQuoteIdByRfqToken();
    const lastId = data[0]?.lastId || 0;

    this.tempFormGroup.patchValue({
      quoteRefNumber:
        'QUOTE-VSMPS-' +
        new Date().getFullYear().toString() +
        String(new Date().getMonth() + 1).padStart(2, '0') +
        String(new Date().getDate()).padStart(2, '0') +
        '-' +
        (lastId + 1),
    });
    }


    this.fetchRfqDetails();

    let attachmentFiles: any = {};
    let formObj = this.tempFormGroup.value;
    let attachmentArray = [...this.uploadedAttachmentsArray];

    attachmentArray = attachmentArray.filter((item) => item.file);

    if (attachmentArray.length === 0) {
      await this.fetchRfqDetails();
      this.FullLoaderService.hideLoader();
      return;
    }

    // generate the s3 upload content for each attachment file
    // 2026-10-26: the quote reference shown here is the browser's guess (the server assigns the real one on save), so it can
    // name ANOTHER supplier's quote; header files go to a fresh folder of their own. The saved attachment rows decide who
    // may open them (Supplier-API utils/file-access.js).
    let uploadPath = `quotation/upload-${uuidv4()}`;
    console.log('upload path', uploadPath);

    await Promise.all(
      attachmentArray.map(async (attachment: any, index: any) => {
        if (!attachment.file) {
          return;
        }
        let fileName = attachment.file.name;
        let fileExt = attachment.name.slice(
          ((attachment.name.lastIndexOf('.') - 1) >>> 0) + 2
        );

        let fileNameSystem = `${uuidv4()}.${fileExt}`;

        attachment.systemName = fileNameSystem; //This name denotes the fileNames for our system records
        let s3Location = `${uploadPath}/${fileName}`; //!this location to be verified before starting upload

        let _s3Params = {
          fileKey: s3Location,
          fileContentType: (<File>attachment.file).type,
        };
        attachment.s3Params = _s3Params;
        attachmentFiles[attachment.file.name] = attachment.file;
      })
    );

    // get presigned urls for all the attachments in bulk
    formObj.quoteHeaderAttachments =
      await this.SettingsService.getBulkAttachmentUrlsByRfqToken(attachmentArray);

    await this.fetchRfqDetails();
    this.FullLoaderService.hideLoader();

    formObj.quoteHeaderAttachments.map(async (attachment: any) => {
      attachment.s3_path = this.awsSdkService.extractS3LocationFromUrl(
        attachment.s3_path
      );
      attachment.fileKey = attachment.s3Params ? attachment.s3Params.fileKey : attachment.fileKey; // 2026-10-26: saved attachments have no s3Params
    });

    // upload all the iamges to s3 bucket
    await Promise.all(
      formObj.quoteHeaderAttachments.map(async (attachment: any) => {
        this.webApiService.putRequestExternalApi(
          attachment.s3_path,
          attachmentFiles[attachment.name]
        );
      })
    );
    console.log('quoteHeaderAttachments', formObj.quoteHeaderAttachments);


    //  this.messages = [
    //   { sender: 'You', message: 'Hello, how are you?', time: '08:00 PM' },
    //   { sender: 'Other', message: 'I am good, thank you! How about you?', time: '08:01 PM' },
    //   { sender: 'You', message: 'I’m doing well, thanks for asking.', time: '08:02 PM' },
    //   { sender: 'Other', message: 'What about the delivery schedule?', time: '08:05 PM' },
    //   { sender: 'You', message: 'The delivery will be in 5-7 business days.', time: '08:06 PM' },
    //   { sender: 'Other', message: 'Great, thanks!', time: '08:07 PM' }
    // ];

    // // Listen for incoming messages from the WebSocket
    // this.chatService.getMessages().subscribe((messageData: any) => {
    //   // Add the incoming message to the chat
    //   const incomingMessage = {
    //     sender: 'Other',  // This is the other user's message (incoming)
    //     message: messageData.message,
    //     time: new Date().toLocaleTimeString(),  // Show current time for simplicity
    //   };
    //   this.messages.push(incomingMessage);
    // });

    this.FullLoaderService.hideLoader();
  }

  async fetchRfqDetailsAttachments(rfqLineItemDetailId: any) {
    this.fullLoaderService.showLoader();
    let params = {
      rfqId: this.rfqId,
      supplierId: this.userId,
      rfqLineItemDetailId: rfqLineItemDetailId,
    };
    // this.FullLoaderService.showLoader();
    const data = await this.quoteService.fetchRfqLineItemAttachmentsByRfqToken(params);
    console.log({ data });
    if (data.lineItemData && data.lineItemData.length > 0) {
      const transformedData: any[] = [];
      data.lineItemData.forEach((item: any, index: number) => {
        transformedData.push({
          // serialNo: (index + 1).toString(),
          // partNumber: item.partNumber,
          // itemDescription: item.itemDescription,
          // uom: item.uom,
          // quantity: item.quantity,
          // buyerComments: item.buyerComments || '-',
          s3Path: item.s3Path,
        });
      });

      this.lineItemDataAttachment = transformedData;
      console.log('lineItemDataAttachment', this.lineItemDataAttachment);
    }

    // this.headerData = data.rfqData[0]
    // this.tempFormGroup.patchValue(
    //     {
    //       supplierRfqDetailsId: this.headerData.supplierRfqId
    //     }
    //   )
    // console.log("headerData",this.headerData);
    this.FullLoaderService.hideLoader();
  }

  async fetchRfqDetails() {

    
    if (this.userRole == 'Suppliers') {

      let params = {
        rfqId: this.rfqId,
        supplierId: this.userId || null,
      };
      // this.FullLoaderService.showLoader();
      const data = await this.quoteService.fetchRfqDetailsByRfqToken(params);
      console.log("rfq details data->",data);
      if (data.lineItemData && data.lineItemData.length > 0) {
        const transformedData: any[] = [];
        data.lineItemData.forEach((item: any, index: number) => {
          transformedData.push({
            serialNo: (index + 1).toString(),
            partNumber: item.partNumber,
            itemDescription: item.itemDescription,
            uom: item.uom,
            quantity: item.quantity,
            buyerComments: item.buyerComments || '-',
            rfqLineItemDetailsId: item.rfqLineItemDetailsId,
          });
        });
  
        this.lineItemData = transformedData;
        console.log('lineItemData', this.lineItemData);
      }
  
      this.headerData = data.rfqData[0];
      this.headerData = {
        ...this.headerData,
        supplierId: this.userId
      };
      this.tempFormGroup.patchValue({
        supplierRfqDetailsId: this.headerData.supplierRfqId,
      });

    }
    else{

      let params = {
        rfqId: this.rfqId,
        supplierId: this.userId || null,
      };
      // this.FullLoaderService.showLoader();
      const data = await this.quoteService.fetchRfqPreviewDetailsByRfqToken(params);
      console.log("rfq details data->",data);
      this.headerData = data[0];
      this.tempFormGroup.patchValue({
        supplierRfqDetailsId: this.headerData.supplierRfqId,
      });

      if (data[0].rfqLineItemDetails && data[0].rfqLineItemDetails.length > 0) {
        const transformedData: any[] = [];
        data[0].rfqLineItemDetails.forEach((item: any, index: number) => {
          transformedData.push({
            serialNo: (index + 1).toString(),
            partNumber: item.partNumber,
            itemDescription: item.itemDescription,
            uom: item.uom,
            quantity: item.quantity,
            buyerComments: item.buyerComments || '-',
            rfqLineItemDetailsId: item.rfqLineItemDetailsId,
          });
        });
  
        this.lineItemData = transformedData;
        console.log('lineItemData', this.lineItemData);
      }
  
      this.headerData = data.rfqData[0];
      this.tempFormGroup.patchValue({
        supplierRfqDetailsId: this.headerData.supplierRfqId,
      });

    }

    
    console.log('headerData', this.headerData);
    // const buyerAttachments: Attachment[] = JSON.parse(
    //   this.headerData.buyerAttachments
    // );

    const buyerAttachments = this.headerData.buyerAttachments;

    // Iterate through the buyerAttachments array and push the s3_path into buyerAttachmentUrl
    // buyerAttachments.forEach(attachment => {
    //   if (attachment.s3_path) {
    //     this.buyerAttachmentUrl.push(attachment.s3_path);
    //   }
    // });

    buyerAttachments.forEach((attachment:any) => {
      if (attachment.s3_path && attachment.name) {
        this.buyerAttachmentUrl.push({
          name: attachment.name,
          s3_path: attachment.s3_path,
        });
      }
    });
    console.log('buyerAttachmentUrl', this.buyerAttachmentUrl);

    // this.FullLoaderService.hideLoader();
  }

  toggleVisibility(section: string) {
    if (section == 'form1') {
      this.isForm1Expand = !this.isForm1Expand;
    } else if (section == 'form2') {
      this.isForm2Expand = !this.isForm2Expand;
    } else if (section == 'form3') {
      this.isForm3Expand = !this.isForm3Expand;
    } else if (section == 'form4') {
      this.isForm4Expand = !this.isForm4Expand;
    } else if (section == 'form5') {
      this.isForm5Expand = !this.isForm5Expand;
    } else if (section == 'form6') {
      this.isForm6Expand = !this.isForm6Expand;
    } else if (section == 'form7') {
      this.isForm7Expand = !this.isForm7Expand;
    } else if (section == 'form8') {
      this.isForm8Expand = !this.isForm8Expand;
    } else if (section == 'form9') {
      this.isForm9Expand = !this.isForm9Expand;
    } else if (section == 'form10') {
      this.isForm10Expand = !this.isForm10Expand;
    } else if (section == 'form11') {
      this.isForm11Expand = !this.isForm11Expand;
    }
  }

  // toggleShowHeaderDetails(event: MatSlideToggleChange){
  //   this.showDetailSection = event.checked;
  //   setTimeout(() => {
  //     if (this.table) {
  //       this.table.recalculate();
  //     }
  //   }, 100);
  // }
  toggleShowHeaderDetails(event: { checked: boolean }) {
    this.showDetailSection = event.checked;
    setTimeout(() => {
      if (this.table) {
        this.table.recalculate();
      }
    }, 100);
  }
  toggleWrapDescription(event: MatSlideToggleChange) {
    this.isWrapDescription = event.checked;
  }

  async draft() {
    this.FullLoaderService.showLoader();
    const params1 = {
      rfqId: this.rfqId,
      supplierId: this.userId,
    };
    const quoteData = await this.quoteService.getQuoteIdByRfqToken(params1);
    console.log({ quoteData });

    if (!quoteData) {
      const params2 = {
        section: 'tab1',
        quoteStatus: 14,
        tabId: 1,
        headerDetails: this.tempFormGroup.value,
      };
      if (this.tempFormGroup.get('quoteId')?.value == null) {
        const result = await this.quoteService.saveQuoteAsDraftByRfqToken(params2);
        if (result?.data) {
          this.quoteId = result.data;
          this.headerData.quoteId = this.quoteId;
          this.snack.open(`Rfq has been Drafted`, 'OK', { duration: 3000 });
        } else {
          throw new Error('Invalid response format: Expected { data: number }');
        }
      }
    } else {
      this.quoteId = quoteData[0]?.quoteId;
      this.headerData.quoteId = this.quoteId;
      // const params3 = {
      //     section: 'tab1',
      //     quoteStatus: 14,
      //     tabId: 1,
      //     headerDetails: this.tempFormGroup.value
      // };
      // const result1 = await this.quoteService.updateQuoteAsDraft(params3);
      // if (result1?.data) {
      //   this.snack.open(`Rfq has been Drafted`, "OK", { duration: 3000 });
      // } else {
      //   throw new Error('Invalid response format: Expected { data: number }');
      // }
      this.snack.open(`Rfq has been already Quoted`, 'OK', { duration: 3000 });
    }

    this.fullLoaderService.hideLoader();
  }

  async createQuote() {
    this.FullLoaderService.showLoader();
    const params1 = {
      rfqId: this.rfqId,
      supplierId: this.userId,
    };
    const quoteData = await this.quoteService.getQuoteIdByRfqToken(params1);
    console.log({ quoteData });

    if (quoteData && quoteData.length > 0) {
      this.quoteId = quoteData[0]?.quoteId;
      this.headerData.quoteId = this.quoteId;
      console.log('Fetched the QuoteId for this rfq');
    } else {
      const params2 = {
        section: 'tab1',
        // quoteStatus: 2,
        quoteStatus: 14,
        tabId: 1,
        headerDetails: this.tempFormGroup.value,
      };
      console.log('headerDetails', params2.headerDetails);
      if (this.tempFormGroup.get('quoteId')?.value == null) {
        const result = await this.quoteService.saveQuoteAsDraftByRfqToken(params2);
        if (result?.data) {
          this.quoteId = result.data;
          this.headerData.quoteId = this.quoteId;
          console.log('quoteId Created in create Quote function', this.quoteId);
        } else {
          throw new Error('Invalid response format: Expected { data: number }');
        }
      }
    }

    this.fullLoaderService.hideLoader();
    console.log("headerData at RFQ Details Level",this.headerData)
    if (this.headerData.quoteId != null) {
      this.router.navigate(['rfqToken', 'quote-line-items'], {
        queryParams: { rfqId: this.rfqId, quoteId: this.headerData.quoteId },
      });
    }
  }

  back() {
    this.rfqTokenAuth.clear();
    this.router.navigate(['/tokenLogin']);
  }

  async rfqActions(action: string) {
    if (action == 'download') {
      this.FullLoaderService.showLoader('Download in progress. Please hold on...');

      let fileName = this.headerData?.rfqRefNumber + '.pdf';

      let data = {
        supplierId: this.userId,
        rfqId: this.rfqId,
      };
      const pdf = await this.SettingsService.generateSupplierRfqAttachmentByRfqToken(
        data
      );

      const uint8Array = new Uint8Array(pdf.data);
      const blob = new Blob([uint8Array], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);

      // Create a temporary <a> element
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      this.FullLoaderService.hideLoader();
    } else if (action == 'decline') {
      this.showDeclineConfirmationDialogue = true;
    } else if (action == 'acknowledge') {
      this.FullLoaderService.showLoader();

      let data = {
        operation: action,
        selectedRfqId: [this.headerData.supplierRfqId],
        rfqId:this.headerData.rfqId,
        rfqNumber:this.headerData.rfqRefNumber,
        buyerId: this.headerData.buyerId,
        supplier:this.headerData.supplierCompanyName,
        vesselName: this.headerData.vesselName
      };

      let params = {
        supplierId: this.userId,
        rfqId:this.rfqId
      }

      await this.SettingsService.rfqOperationsByRfqToken(data);
       await this.quoteService.sendAcknowledgeRfqAcknowledgmentByRfqToken(params);
      this.FullLoaderService.hideLoader();
      this.snack.open('RFQ has been acknowledged', 'OK', {
        duration: 3000,
      });

      this.fetchRfqDetails();
      this.router.navigate(['/operations/supplier-rfq-list'], {
        queryParams: { updatedStatus: 'Acknowledged' },
      });
    }
  }

  cancelDecline() {
    this.showDeclineConfirmationDialogue = false;
    this.declineReason = '';
  }

  async declineRfq() {
    this.FullLoaderService.showLoader();

    this.showDeclineConfirmationDialogue = true;
    let data = {
      declineReason: this.declineReason,
      supplierRfqDetailsId: this.headerData.supplierRfqId,
      rfqId:this.rfqId,
      rfqNumber:this.headerData.rfqRefNumber,
      buyerId: this.headerData.buyerId,
      supplier:this.headerData.supplierCompanyName,
      vesselName: this.headerData.vesselName
    };
    console.log("data sent for declining rfq->",data);

    await this.quoteService.declineRfqByRfqToken(data);

    let params = {
      supplierId:this.userId,
      rfqId:this.rfqId,
    }

    await this.quoteService.sendDeclineRfqAcknowledgmentByRfqToken(params);
    this.FullLoaderService.hideLoader();
    this.showDeclineConfirmationDialogue = false;
    this.snack.open('RFQ has been declined', 'OK', {
      duration: 3000,
    });

    this.fetchRfqDetails();
    this.router.navigate(['/operations/supplier-rfq-list'], {
      queryParams: { updatedStatus: 'Declined' },
    });
  }
  //  My work Akarsh Singh

  
   isChatOpen = false;
  newMessage = '';
  messages: { sender: string; message: string; time: string }[] = [];

  openChat() {
    this.isChatOpen = true;
  }

  closeChat() {
    this.isChatOpen = false;
  }

  

  // sendMessage() {
  //   if (this.newMessage.trim()) {
  //     // Create the message object to send
  //     const messageData = {
  //       message: this.newMessage,  // Message typed by the sender
  //       rfqId: this.rfqId,         // RFQ ID associated with the message
  //       userId: this.userId,       // User ID of the sender (either Buyer or Supplier)
  //     };
  //     console.log('Message data to send:', messageData);

  //     // Send the message to the backend via WebSocket
  //     this.chatService.sendMessage(messageData);

  //     // Add the message to the sender's chat UI immediately
  //     const outgoingMessage = {
  //       sender: 'You',  // Sender is the current user (outgoing)
  //       message: this.newMessage,
  //       time: new Date().toLocaleTimeString(),  // Show current time for simplicity
  //     };

  //     this.messages.push(outgoingMessage);
  //     console.log('Sending message:', outgoingMessage);

  //     // Clear the input field after sending the message
  //     this.newMessage = '';
  //   }
  // }

//   onFileSelected(event: Event) {
//     const file = (event.target as HTMLInputElement).files?.[0];
//     if (file) {
//       console.log('File selected:', file.name);
//       // Implement file upload logic here
//     }
//   }
//   formatDateToDDMMYYYY(dateString:string) {
//     const date = new Date(dateString);
//     const day = String(date.getDate()).padStart(2, '0');  // Add leading zero if day is less than 10
//     const month = String(date.getMonth() + 1).padStart(2, '0');  // Add leading zero if month is less than 10
//     const year = date.getFullYear();
  
//     return `${day}/${month}/${year}`;
// }
get userIdAsString(): string {
  return this.userId.toString();
}
}
